import "../styles.css"
export const Banner=() =>{
    return (
        <div>
            <img className="banner" src="https://d2407na1z3fc0t.cloudfront.net/Slider/banner_62a882919ddbf" alt="banner" />
        </div>
    )
}